export default __webpack_public_path__ + "static/intro-cond-regular-04172ab1abcdba42a6f2b9f6ca0a9ece.woff2";